// ASK-106 — the lid's open angle is the manifest's (`open-close` `hinge.openAngleRad`, carried on the
// composed entry as `lidOpenAngle`). A value that is absent, non-finite or outside (0, π) is "no
// opinion" and the stage's own constant answers; it is never coerced to 0 (a lid that never opens)
// or past π (a lid through the floor).
export function lidOpenAngleFor(authored, fallback) {
	return (Number.isFinite(authored) && authored > 0 && authored < Math.PI) ? authored : fallback;
}
